<template>
  <el-dialog title="编辑其他类采购单" :visible.sync="dialogTableVisible" width="55%">
    <el-row class="border-bottom padding">
      <el-col :span="24" class="line-height">采购单号：{{this.sondata.purchaseNumber}}</el-col>
      <el-col :span="24" class="line-height">采购说明</el-col>
      <el-col :span="12" class="line-height">
        <el-input
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 4}"
          placeholder="请输入内容"
          v-model="Explain"
          :disabled="disable1"
        ></el-input>
      </el-col>
      <el-col :span="19" class="line-height padding">
          <span>采购列表</span>
          <el-button style="margin-left:20px;" type="primary" @click="AddPurchaselist" :disabled="disable">新增采购</el-button>
      </el-col>
      <el-col :span="24">
        <el-table :data="Purchaselist" border style="width: 100%">
          <el-table-column prop="Order" label="名称">
            <template slot-scope="scope">
              <el-input v-model="scope.row.purchasedItemName" :disabled="disable"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="describe" label="规格描述">
            <template slot-scope="scope">
              <el-input v-model="scope.row.specificationModel" :disabled="disable"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="UnitPrice" label="采购单价">
            <template slot-scope="scope">
              <el-input v-model="scope.row.purchasePrice" :disabled="disable"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="link" label="采购链接">
            <template slot-scope="scope">
              <el-input v-model="scope.row.purchaseLink" :disabled="disable"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="Company" label="单位">
            <template slot-scope="scope">
              <el-input v-model="scope.row.unit" :disabled="disable"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="Numberm" label="数量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.quantity" :disabled="disable"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="Warehousing" label="运单号">
            <template slot-scope="scope">
              <el-input v-model="scope.row.internalConveyNumber" :disabled="disable1"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="UpdateTime" label="备注">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remarks" :disabled="disable1"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="danger" @click="dele(scope.row)" :disabled="disable">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" class="line-height" style="margin-top:10px;">
        <span>采购总计:</span>
        <el-input-number v-model="num" size="mini" :min="0" label="总计" style="margin-left:20px;" :disabled="disable1"></el-input-number>
        <el-button type="primary" style="margin-left:20px;" @click="Confirm" :disabled="disable">确认支付</el-button>
      </el-col>
    </el-row>
    <div class="demo-image__preview">
      <div v-for="item in this.repayCredentialsList" class="imageList">
        <el-image 
          style="width: 100px; height: 100px"
          :src="item.url" 
          :preview-src-list="item.repayCredentialsList">
        </el-image>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="TheEnd" v-if="this.sondata.purchaseStatus !=4&& this.sondata.paymentStatus === 1">单据完结</el-button>
      <el-button type="primary" @click="complete">完成</el-button>
    </div>

    <el-dialog title="支付凭证" :visible.sync="credentials" width="27%" append-to-body>
      <div>
        <el-upload
              ref='upload'
              :action="action"
              list-type="picture-card"
              :on-success="handleAvatarSuccess"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :headers="customHeaders"
          >
          <i class="el-icon-plus" style="color: #0724ef;"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" append-to-body>
              <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
      </div>
      <div style="margin-top:20px;">请添加该采购单据的相关支付凭证，如：下单截图、支付截图等</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirmPay">确认支付</el-button>
      </span>
    </el-dialog>

  </el-dialog>
</template>

<script>
import { ajaxPost ,Baseurl} from '../../../api/api/api';
export default {
  name: "Otherprocurementedit",
  data() {
    return {
      dialogTableVisible: false,
      credentials:false,
      dialogVisible:false,
      action: Baseurl + "imageController/uploadImage",
      customHeaders: { token: localStorage.getItem("token") },
      dialogImageUrl: [],
      imageData: [],
      arr:[],
      str:"",
      Explain: "",
      sondata:"",
      num:"",
      Purchaselist: [
        {
          name: "",
          describe: "",
          UnitPrice: "",
          link: "",
          Company: "",
          Numberm: "",
          Order: "",
          Remarks: ""
        }
      ],
      disable:false,
      disable1:false,
      repayCredentialsList:""
    };
  },
  mounted() {},
  created() {
    this.str = JSON.parse(window.localStorage.getItem("role"));
  },
  methods: {
    init(e) {
      this.dialogTableVisible = true;
      this.sondata = e
      this.Explain = this.sondata.purchaseInstructions
      this.num  = this.sondata.purchaseTotalAmount
      this.repayCredentialsList = this.sondata.repayCredentialsList
      // console.log(this.repayCredentialsList)
      // console.log(this.sondata)
      this.procurementList()
      if(this.sondata.purchaseStatus === 4){
        this.disable = true
        this.disable1 = true
      }else{
        this.disable = false
        this.disable1 = false
      }
      if(this.sondata.paymentStatus === 1){
        this.disable = true
      }else{
        this.disable = false
      }
    },
    procurementList(){
      var obj = {
        purchaseNumber:this.sondata.purchaseNumber
      }
      ajaxPost(Baseurl + "generalProcurementController/selectGeneralProcurementItemInfo", obj).then(res => {
          this.Purchaselist = res.data.data
      });
    },
    complete(){
      if(this.sondata.purchaseStatus === 4){
        this.$message({
            message: '该采购单已完结',
            type: 'success'
        });
        this.dialogTableVisible = false
      }else{
        var obj = {
          id:this.sondata.id,
          purchaseTotalAmount:this.num,
          purchaseInstructions:this.Explain,
          generalProcurementList:this.Purchaselist,
          purchaseNumber:this.sondata.purchaseNumber
        }
        ajaxPost(Baseurl + "generalProcurementController/updateGeneralProcurement",obj).then(res => {
            if(res.data.code == 200){
                this.$message({
                    message: '编辑其他类采购单成功',
                    type: 'success'
                });
                this.$emit("Edit")
            }else(
                this.$message.error(res.data.data)
            )
            this.dialogTableVisible = false
        })
      }
      
    },
    AddPurchaselist() {
      const param = {
        id: this.Purchaselist.id,
        purchasedItemName: "",
        specificationModel: "",
        purchasePrice: "",
        purchaseLink: "",
        unit:"",
        quantity: "",
        internalConveyNumber: "",
        remarks: ""
      };
      this.Purchaselist.push(param);
    },
    dele(val){
      console.log(val)
        this.$confirm('删除当前采购物品信息?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            var obj = {
                id:val.id,
                purchaseNumber:val.purchaseNumber
            }
            ajaxPost(Baseurl + "generalProcurementController/deleteGeneralProcurementItemInfo",obj).then(res => {
              if(res.data.code == 200){
                  this.$message({
                      message: '删除当前采购物品信息成功',
                      type: 'success'
                  });
                  this.Purchaselist = res.data.data
              }else(
                  this.$message.error(res.data.data)
              )
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    Confirm(){
      this.credentials = true
    },
    //图片上传
    handleAvatarSuccess(file, fileList) {
        this.imageData.push(file);
    },
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
    },
    handleRemove(file, fileList) {
        this.imageData = [];
        for (var i = 0; i < fileList.length; i++) {
            this.imageData.push(fileList[i].response);
        }
    },
    cancel(){
      this.credentials = false
      this.$refs.upload.clearFiles(); 
    },
    confirmPay(){
      for (var i = 0; i < this.imageData.length; i++) {
            this.arr.push(this.imageData[i].data);
      }
      console.log(this.arr)
      var obj = {
        id:this.sondata.id,
        purchaseTotalAmount:this.num,
        purchaseRoleId:this.str.rid,
        purchaseNumber:this.sondata.purchaseNumber,
        uploadCertificates:this.arr
      }
      ajaxPost(Baseurl + "generalProcurementController/updatePurchasePayStatus",obj).then(res => {
          if(res.data.code == 200){
              this.$message({
                  type: "success",
                  message: "确认支付成功"
              });
              this.dialogTableVisible = false
              this.$emit("Edit")
              this.disable = true
              this.repayCredentialsList = res.data.data.repayCredentialsList
          }else(
              this.$message.error(res.data.data)
          )
          this.arr = []
          this.imageData = [];
          this.$refs.upload.clearFiles(); 
      })
      console.log(this.imageData)
      this.credentials = false
    },
    TheEnd(){
      var obj = {
        id:this.sondata.id
      }
      ajaxPost(Baseurl + "generalProcurementController/completeTheDocument",obj).then(res => {
          if(res.data.code == 200){
              this.$message({
                  type: "success",
                  message: "单据完结成功"
              });
              this.disable1 = true
              this.disable = true
              this.$emit("Edit")
          }else(
              this.$message.error(res.data.data)
          )
      })
      this.dialogTableVisible = false
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ {
  .el-dialog__body {
    padding: 13px 20px;
  }
  .demo-image__preview{
    display: flex;
    justify-content: left;
    margin-top: 20px;
  }
}
.line-height {
  line-height: 35px;
}
.padding {
  padding: 10px 0;
}
img {
  width: 100%;
  height: 100%;
}
.imageList{
  margin-left: 20px;
}
</style>